import { Button } from 'flowbite-react';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import { Link, useNavigate } from 'react-router-dom';
import Editor from '../Common/Editor';
import SettingsApi from '../../Api/SettingsApi';
import { ServerSetting } from '../../Models/ServerSetting';
import DeliveryApi from '../../Api/DeliveryApi';
import { TestEmail } from '../../Models/TestEmail';

export default function DeliveryCompleteEmail() {
  const navigate = useNavigate();
  const { userModel } = useAppSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [setting, setsetting] = useState<ServerSetting>({
    keySettingId: 0,
    settingName: null,
    settingValue: null,
    usageNotes: null,
  });
  const [htmlValue, sethtmlValue] = useState('');
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  useEffect(() => {
    getServerSetting();
  }, []);

  const getServerSetting = () => {
    if (userModel) {
      try {
        setIsLoading(true);
        return SettingsApi.getServerSetting('DeliveryCompleteEmail')
          .then((res) => {
            setsetting(res.data);
            sethtmlValue(res.data.usageNotes ?? '');
            setIsLoading(false);
          })
          .catch((err) => {
            console.error(err);
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  };

  // const handleAssetClick = () => {
  //   setshowAddAsset(true);
  // };

  // const editAsset = (Asset: Asset) => {
  //   setselectedAsset(Asset);
  //   setshowAddAsset(true);
  // };

  // function deleteAsset(id: number) {
  //   const shouldRemove = window.confirm(
  //     'Are you sure you want to delete this?'
  //   );

  //   if (shouldRemove) {
  //     AssetApi.deleteAsset(id)
  //       .then((res) => {
  //         if (res.data.success) {
  //           toast.success(res.data.message);
  //           // getAssetList();
  //         } else {
  //           toast.success('Error while deleting item');
  //         }
  //       })
  //       .catch((err) => {
  //         toast.error('Error: ' + err);
  //       });
  //   }
  // }

  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  const sendTestEmail = async () => {
    setButtonDisabled(true);
    const testEmail = {
      emailBody: htmlValue,
    } as TestEmail;
    DeliveryApi.sendDeliveryEmailTest(testEmail)
      .then((res) => {
        if (res.data.success) {
          toast.success('Test Email Sent');
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error('Error');
      });
    setButtonDisabled(false);
  };

  const onSubmit = async () => {
    setButtonDisabled(true);
    setIsLoading(true);
    setting.usageNotes = htmlValue;
    SettingsApi.updateServerSetting(setting)
      .then((res) => {
        if (res.data.success) {
          toast.success('Success');
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error('Error');
      });
    setIsLoading(false);
    setButtonDisabled(false);
    navigate('/Settings');
  };

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Delivery Complete Email</div>
              </h1>
            </div>
          </div>
        </div>
        <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
          <div className='relative'>
            {isLoading && <Loader />}
            <div>
              <Editor
                id='description'
                name='description'
                value={htmlValue}
                className='w-full'
                changedValue={sethtmlValue}
                placeholders={[
                  '[CustomerName]',
                  '[OrderNumber]',
                  '[DeliveryDate]',
                  '[DeliveredQuantity]',
                  '[YourFullName]',
                  '[YourPosition]',
                  '[YourContactInformation]',
                  '[CompanyName]',
                  '[CompanyAddress]',
                  '[CopmpanyPhone]',
                  '[CompanyEmail]',
                ]}
              />
            </div>
            <div className={`flex justify-between pt-2`}>
              <Button
                type='button'
                className='buttonMain'
                onClick={sendTestEmail}
                disabled={buttonDisabled}
              >
                Send Test Email
              </Button>
              <Button
                type='button'
                className='buttonMain'
                onClick={onSubmit}
                disabled={buttonDisabled}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
